module.exports = __webpack_public_path__ + "img/maPread_text_light.2d00965b.svg";